
import { useContext, useEffect, useState } from "react";
import { SettingsHeader } from "../molecule/settingsHeader";
import { DynamicModal } from "./CustomerSettings";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { deleteAPI, getAPI, postAPI } from "../api/api";
import { ToastContext } from "../App";
import { UserContact } from "../molecule/userContact";
import { StandardButton } from "../atoms/buttons";
import { ProfileComp } from "./profileComp";
import { User } from "../atoms/user";
import { TitleDescription } from "./titleDescription";
import { TitleDescriptionText } from "../atoms/titleDescription";
import { FeatureCard } from "../molecule/activateFeatures";
import { Divider } from "../atoms/divider";
import { InputForm } from "../atoms/input";
import { TextAtom } from "../atoms/TextAtom";
import { Spinner } from "../atoms/spinner";

export const LinkedinSettings = () => {
    const toast = useContext(ToastContext)
    const [active, setActive] = useState(false)
    const [userData, setUserData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const activateLinkedin = () => {
        setActive(!active)
    }

    const activateAccount = async () => {
        const query = 'api/linkedin/authenticate'
        const body = {}
        body.email = userData.email
        body.password = userData.password
        setIsLoading(!isLoading)
        const activate = await postAPI(query, body)
        if (activate.status == "ok") {
            activateLinkedin()
            setIsLoading(!isLoading)
            toast.showToast('Linkedin account is succesvol gekoppeld!', 'success')
            return
        }
        activateLinkedin()
        setIsLoading(!isLoading)
        toast.showToast('Kon geen verbinding maken met uw linkedin account', 'error')
    }
    const sendCode = async () => {
        const query = "api/linkedin/code"
        const body = {}
        body.code = userData.code

         await postAPI(query,body)
        setUserData({...userData,send : true})
    }
    const styles = {
        boxSizing: "border-box",
        borderColor: "var(--border-color)",
        borderRadius: "0.5rem",
        borderWidth: "1px",
        borderStyle: "solid",
        overflow: "hidden",
        height: "unset"
    }
    return (
        <VerticalLayout className="settings-card" style={{ height: "unset" }}>

            <SettingsHeader
                title={"Verbinding Linkedin"}
                description={"Maak en beheer hier je linkedin account"}
                toggleAddModal={activateLinkedin}
            />

            <VerticalLayout className="settings-rows" style={{ margin: "0rem", marginTop: "unset", padding: "1rem", width: "unset", paddingTop: 0, gap: "1rem", height: "unset" }}>
                <VerticalLayout
                    style={styles}
                >
                    <LinkedinAccount
                        reload={isLoading}
                    />

                    <DynamicModal
              
                        title={"Linkedin verbinding"}
                        content={<ModalContent isLoading={isLoading} userData={userData} setUserData={setUserData} />}
                        visible={active}
                        actions={{ "cancel": activateLinkedin, "submit": isLoading?sendCode:activateAccount, submitTitle: isLoading?"Verstuur code":"Maak nu verbinding" }} />
                </VerticalLayout>

                <LinkedinSettingActions />
            </VerticalLayout>

        </VerticalLayout>
    );
}

const ModalContent = ({ userData,setUserData, isLoading }) => {
    

    return (
       !isLoading? <VerticalLayout>
            <TextAtom
                style={{ color: "var(--standard-text-color-light)", marginBottom: "1rem" }}
                title={"Koppel hier je account. We slaan deze gegevens niet op maar houden de verbinding in stand."}
            />
            <InputForm
                title={"Email"}
                value={userData?.email}
                typeInput={(text) => setUserData({ ...userData, email: text })}
            />
            <InputForm
                title={"Wachtwoord"}
                value={userData?.password}
                typeInput={(text) => setUserData({ ...userData, password: text })}
                password={true}
            />
        </VerticalLayout>
        :
        <VerticalLayout>
            <Spinner/>
             {!userData?.send == true &&<InputForm
                title={"Activatie code"}
                value={userData?.code}
                typeInput={(text) => setUserData({ ...userData, code: text })}
                
            />}
        </VerticalLayout>
    )
}
const LinkedinAccount = ({reload}) => {

    const [profile, setProfile] = useState({})
    useEffect(() => {
        loadAccount()
    }, [reload])
    const loadAccount = async () => {
        const query = "api/linkedin/profile"
        const load = await getAPI(query)
        setProfile(load.data)
    }
    const removeAccount = async () => {
        const query = "api/linkedin/remove-account"
        const body = {}
        const remove = await deleteAPI(query)
        if(remove.status == "ok"){
                loadAccount()
        }
    }
    var avatarSrc = profile.name && `https://ui-avatars.com/api/?name=${profile.name}&background=random&color=fff&format=svg`;
    return (
        <HorizontalLayout style={{ justifyContent: "space-between", padding: "0.5rem", width: "unset" }}>
            <User avatar={avatarSrc} name={profile.name} email={profile.name ? "Verbonden via linkedin":"niet verbonden via linkedin"} />
            {profile.name && <StandardButton 
                onClick={removeAccount}

                title={"Verbinding verbreken"}
                className={"primary-button alert error-alert"}
                textColor={"var(--error-600)"}
                backgroundColor={"unset"}
            />}
        </HorizontalLayout>
    )
}

const LinkedinSettingActions = () => {
    const [features, setFeatures] = useState([
    ])
    useEffect(() => {
        loadFeatures()
    }, [])

    const loadFeatures = async () => {
        const query = "api/linkedin/features"
        const load = await getAPI(query)
        if (load.data) {
            setFeatures(load.data)
        }
    }
    const activateFeature = async (index) => {
        const copy_features = [...features]
        copy_features[index].checked = !copy_features[index].checked
        const query = "api/linkedin/features/update"
        const body = copy_features.filter(feature => feature.checked)
        console.log(body)
        const update = await postAPI(query, body)
        setFeatures(copy_features)

    }
    return (
        <VerticalLayout
            style={{
                boxSizing: "border-box",
                borderColor: "var(--border-color)",
                borderRadius: "0.5rem",
                borderWidth: "1px",
                borderStyle: "solid",
                overflow: "hidden",
                height: "unset",
                padding: "1rem"

            }}
        >
            <TitleDescriptionText
                style={{ justifyContent: "unset", paddingTop: "unset", marginTop: "unset" }}
                title={"Automatisering & Features"}
                description={"Configureer hoe actief het systeem namens jou handelt op LinkedIn."}
            />
            <Divider />
            {features.map((feature, index) => {
                return (
                    <LinkedinFeature
                        feature={feature}
                        activate={() => activateFeature(index)}
                    />
                )
            })}
        </VerticalLayout>
    )
}


const LinkedinFeature = ({ feature, activate }) => {
    return (
        <FeatureCard
            feature={feature}
            activate={activate}
        />
    )
}